class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalDialog = this.querySelector('[data-modal-dialog]');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.modalDialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.modalDialog?.addEventListener('click', this.onDialogClick.bind(this));
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  onDialogClick(event) {
    if (event.target !== this.modalDialog) return;

    const rect = this.modalDialog.getBoundingClientRect();
    const clickedInside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!clickedInside) this.close(false);
  }

  openDialog() {
    if (!this.modalDialog) return;

    const header = this.closest('.section-header') || this.closest('header');
    const anchorBottom = header?.getBoundingClientRect().bottom ?? this.summaryToggle.getBoundingClientRect().bottom;
    const modalTop = Math.max(0, Math.min(window.innerHeight, anchorBottom));
    this.modalDialog.style.setProperty('--yn-search-modal-top', `${modalTop}px`);
    if (!this.modalDialog.open) this.modalDialog.showModal();
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.openDialog();
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      (this.modalDialog || this.detailsContainer).querySelector('[tabindex="-1"]'),
      (this.modalDialog || this.detailsContainer).querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.modalDialog?.open) this.modalDialog.close();
    this.modalDialog?.style.removeProperty('--yn-search-modal-top');
  }
}

customElements.define('details-modal', DetailsModal);
